import { assert } from "@faro-lotv/foundation";

/**
 * @returns An OffscreenCanvas element containing the given image data
 * @param imageData The image data to initialize the canvas with
 */
export function createOffscreenCanvasForImageData(
  imageData: ImageData,
): OffscreenCanvas {
  assert(
    OffscreenCanvas,
    "OffscreenCanvas is not supported in this environment. Please update your browser to use this feature.",
  );

  const canvas = new OffscreenCanvas(imageData.width, imageData.height);

  const ctx = canvas.getContext("2d");
  assert(ctx, "Could not create canvas for imageData");
  ctx.putImageData(imageData, 0, 0);

  return canvas;
}
